import { createContext } from 'react';
import { Project } from './ProjectHeader';

export type ProjectContextValue = {
  project: Project | null;
  setProject: (newProject: Project) => void;
  reloadProject: () => void;
};

export const ProjectContext = createContext<ProjectContextValue>({
  project: null,
  setProject: () => {
    throw new Error('Project Context has not been initialised yet');
  },
  reloadProject: () => {
    throw new Error('Project Context has not been initialised yet');
  },
});
